import { z } from 'zod';

export const StageNoteSchema = z.object({
  id: z.string().uuid(),
  content: z.string(),
  parentId: z.string().uuid(),
  parentType: z.string(),
  stageId: z.string().uuid(),
  createdDateTime: z.string(),
  createdById: z.string().uuid(),
  modifiedDateTime: z.string().nullable(),
  createdBy: z
    .object({
      id: z.string().uuid(),
      fullName: z.string(),
    })
    .nullable(),
});
